// File: frontend/src/pages/InvestorPitch/configs/InvestorSeriesAMasterConfig.js

import React from 'react';
import * as Slides from '../slides';

// Master deck that includes all existing presentations
export const getInvestorSeriesAMasterSlides = (t) => [
  // Series A Core Slides
  {
    id: 'intro',
    title: t('investor_pitch.slides.intro.title'),
    content: <Slides.IntroSlide />
  },
  {
    id: 'revenue-projections',
    title: t('investor_pitch.slides.revenue_projection.title'),
    content: <Slides.RevenueProjection />
  },
  {
    id: 'market-position',
    title: t('investor_pitch.slides.market_position.title'),
    content: <Slides.MarketPositionSlide />
  },
  {
    id: 'traction',
    title: t('investor_pitch.slides.traction.title'),
    content: <Slides.TractionSlide />
  },
  {
    id: 'saving-has-no-language',
    title: t('investor_pitch.slides.saving_has_no_language.title'),
    content: <Slides.SavingHasNoLanguageSlide />
  },
  {
    id: 'go-to-market',
    title: t('investor_pitch.slides.go_to_market.title'),
    content: <Slides.GoToMarketSlide />
  },
  {
    id: 'obsessed-with-data',
    title: t('investor_pitch.slides.obsessed_with_data.title'),
    content: <Slides.ObsessedWithDataSlide />
  },
  {
    id: 'ai1-engineering',
    title: t('investor_pitch.slides.ai1_engineering.title'),
    content: <Slides.AI1Engineering />
  },
  {
    id: 'engineering-metrics',
    title: t('investor_pitch.slides.engineering_metrics.title'),
    content: <Slides.EngineeringMetrics />
  },
  {
    id: 'investment-opportunity',
    title: t('investor_pitch.slides.investment_opportunity.title'),
    content: <Slides.InvestmentOpportunitySlide />
  },
  {
    id: 'leadership',
    title: t('investor_pitch.slides.leadership.title'),
    content: <Slides.LeadershipSlide />
  },
  {
    id: 'historical-invention',
    title: t('investor_pitch.slides.historical_invention.title'),
    content: <Slides.HistoricalInventionSlide />
  },
  {
    id: 'product-evolution',
    title: t('investor_pitch.slides.product_evolution.title'),
    content: <Slides.ProductEvolutionSlide />
  },
  {
    id: 'go-to-market-execution',
    title: t('investor_pitch.slides.go_to_market_execution.title'),
    content: <Slides.GoToMarketExecutionSlide />
  },
  {
    id: 'closing',
    title: t('investor_pitch.slides.closing.title'),
    content: <Slides.ClosingSlideInv />
  },
  
  // Series A Appendix Slides
  {
    id: 'research',
    title: t('investor_pitch.slides.research.title'),
    content: <Slides.ScientificArticlesSlide />
  },
  {
    id: 'security',
    title: t('investor_pitch.slides.security.title'),
    content: <Slides.SecuritySlide />
  },
  {
    id: 'hiring',
    title: t('investor_pitch.slides.hiring.title'),
    content: <Slides.HiringSlide />
  },
  {
    id: 'data-room',
    title: t('investor_pitch.slides.data_room.title'),
    content: <Slides.DataRoomSlide />
  },
  {
    id: 'valuation-model',
    title: t('investor_pitch.slides.valuation_model.title'),
    content: <Slides.ValuationModelSlide />
  },
  {
    id: 'valuation-model-series-a',
    title: t('investor_pitch.slides.valuation_model.title'),
    content: <Slides.ValuationModelSlideSeriesA />
  },
  
  // Additional Slides (Marketing & Technical)
  {
    id: 'technology',
    title: t('investor_pitch.slides.technology.title'),
    content: <Slides.TechnologySlide />
  },
  {
    id: 'growth',
    title: t('investor_pitch.slides.growth.title'),
    content: <Slides.GrowthSlide />
  },
  {
    id: 'technical-architecture',
    title: t('investor_pitch.slides.technical_architecture.title'),
    content: <Slides.TechnicalArchitectureSlide />
  },
  {
    id: 'investment',
    title: t('investor_pitch.slides.investment.title'),
    content: <Slides.InvestmentSlide />
  },
  {
    id: 'market-impact',
    title: t('investor_pitch.slides.market_impact.title'),
    content: <Slides.MarketImpactSlide />
  },
  {
    id: 'global-hiring',
    title: t('investor_pitch.slides.global_hiring.title'),
    content: <Slides.GlobalHiringSlide />
  },
  {
    id: 'animated-hiring',
    title: t('investor_pitch.slides.animated_hiring.title'),
    content: <Slides.AnimatedHiringSlide />
  },
  {
    id: 'partnerships',
    title: t('investor_pitch.slides.partnerships.title'),
    content: <Slides.PartnershipsSlide />
  },
  {
    id: 'market-entry',
    title: t('investor_pitch.slides.market_entry.title'),
    content: <Slides.MarketEntrySlide />
  },
  {
    id: 'competitive-advantage',
    title: t('investor_pitch.slides.competitive_advantage.title'),
    content: <Slides.CompetitiveAdvantageSlide />
  },
  {
    id: 'demo',
    title: t('investor_pitch.slides.demo.title'),
    content: <Slides.DemoSlide />
  },
  {
    id: 'insurance-future',
    title: t('investor_pitch.slides.insurance_future.title'),
    content: <Slides.InsuranceFutureSlide />
  },
  {
    id: 'vision',
    title: t('investor_pitch.slides.vision.title'),
    content: <Slides.VisionSlide />
  },
  {
    id: 'expense-analysis',
    title: t('investor_pitch.slides.expense_analysis.title'),
    content: <Slides.ExpenseAnalysisSlide />
  },
  {
    id: 'methodology',
    title: t('investor_pitch.slides.methodology.title'),
    content: <Slides.MethodologySlide />
  },
  {
    id: 'distribution-model',
    title: t('investor_pitch.slides.distribution_model.title'),
    content: <Slides.DistributionModelSlide />
  },
  {
    id: 'waterfall',
    title: t('investor_pitch.slides.waterfall.title'),
    content: <Slides.WaterfallSlide />
  },
  {
    id: 'model-parameters',
    title: t('investor_pitch.slides.model_parameters.title'),
    content: <Slides.ModelParametersSlide />
  },
  {
    id: 'interactive-bubble-system',
    title: t('investor_pitch.slides.interactive_bubble_system.title'),
    content: <Slides.InteractiveBubbleSystem />
  },
  {
    id: 'standard-closing',
    title: t('investor_pitch.slides.standard_closing.title'),
    content: <Slides.ClosingSlide />
  }
];